
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.83 12L3 9.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L5.83 12zm9.58-3L17 10.59 15.59 12 14 10.41 12.41 12 11 10.59 12.59 9 11 7.41 12.41 6 14 7.59 15.59 6 17 7.41 15.41 9zM18 2h-8L8 0H2C.9 0 .01.9.01 2L0 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H2V2h5.17l2 2H18v10z","fill":"#0B0E1F"}})])
          )
        }
      }
    